import * as Yup from "yup";

export const amcExpirySchema = Yup.object({

    startDate: Yup.string().required("Please Select Start Date"),
    endDate: Yup.string().required("Please Select End Date"),
    // customerName: Yup.string().required("Please Select Customer Name"),


});